export const SET_ROSEKS = (state, payload) => {
    state.rosekData = payload;
}